import { createFileRoute, redirect } from '@tanstack/react-router';

import { sessionQueries } from '@/api';
import { PaymentsPage } from '@/features/payments/payments-page';

export const Route = createFileRoute('/payments')({
	beforeLoad: async ({ context }) => {
		const session = await context.queryClient.ensureQueryData(sessionQueries.current());
		if (!session) throw redirect({ to: '/login', search: { redirect: '/payments' } });
	},
	component: PaymentsPage,
	staticData: { workspace: true },
});
